import React from 'react'
import { Updater, Widget, any, fromJSX } from 'widgets-for-react'
import { GenericPageHeader } from '../../../sharedLayout/pageheader'
import { blocksWidget } from '../../blocks/blocksWidget'
import { cmsPageStateUpdaters, Page, ResearchPage } from '../../cmsPageState'

export const researchPageWidget =
  (acceptVideoCookie: () => void) =>
  (page: ResearchPage): Widget<Updater<Page>> =>
    any([
      fromJSX(() => (
        <GenericPageHeader
          kind="researchDetail"
          title={page.title}
          intro={page.intro}
          image={page.image}
          link={page.link}
          breadcrumbs={[
            { title: 'Spaarne Gasthuis', url: '/' },
            { title: 'Wetenschappelijke onderzoeken', url: '/wetenschappelijke-onderzoeken' },
            { title: page.title, url: page.url },
          ]}
        />
      )),
      blocksWidget(acceptVideoCookie)(page.blocks).map((updater) => cmsPageStateUpdaters.blocksUpdater(updater)),
    ])
